var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-scrollbar__wrap wrap-white" }, [
    _c(
      "div",
      { staticClass: "el-scrollbar__view" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          _vm._l(_vm.dataList, function (item, index) {
            return _c(
              "el-col",
              { key: index, attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 } },
              [
                _c(
                  "el-card",
                  {
                    staticStyle: { margin: "10px" },
                    attrs: {
                      shadow: "hover",
                      "body-style": { padding: "0px" },
                    },
                  },
                  [
                    _c("div", { staticClass: "jp-card jp-card-bordered" }, [
                      _c(
                        "div",
                        { staticClass: "jp-card-cover1" },
                        [
                          _c("i", {
                            class: item.icon,
                            staticStyle: { "font-size": "36px" },
                          }),
                          _c(
                            "div",
                            { staticClass: "jp-card-meta-detail" },
                            [
                              _c(
                                "font",
                                { staticStyle: { "font-weight": "700" } },
                                [_vm._v(" " + _vm._s(item.name))]
                              ),
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "700" } },
                                [_vm._v(_vm._s(item.version))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("font", { attrs: { size: "4" } }, [
                                    _vm._v(_vm._s(item.name) + "("),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: item.site,
                                          target: "blank",
                                        },
                                      },
                                      [_vm._v("访问官网")]
                                    ),
                                    _vm._v(")"),
                                  ]),
                                  _c("br"),
                                  _c("p", {
                                    staticStyle: { "font-weight": "500" },
                                    domProps: {
                                      innerHTML: _vm._s(item.description),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v("详情"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }